import { initialFormState } from '../../../subcomponents/form/form/types/state';
import { defaultGiftCardPaymentFormData } from './data';
export const initialGiftCardPaymentFormState = Object.assign(Object.assign({}, initialFormState), { formData: defaultGiftCardPaymentFormData });
